export default "__VITE_ASSET__CDhzzJir__"